import SettingsIcon from '@mui/icons-material/Settings';

export const OrganizationIcon = () => <SettingsIcon />;
